import { ImageService, RecipeCollectionService, SearchService } from '@/services';
import { useTranslation } from 'react-i18next';


export function useApi() {
    const { i18n } = useTranslation();

    return {
        ImageService: new ImageService(i18n.language),
        RecipeCollectionService: new RecipeCollectionService(i18n.language),
        SearchService: new SearchService(i18n.language),
    };
}
